angular.module('bmsApp.trugreen.job').controller('TGJobIndexCtrl',
	function ($state,
			  $scope,
			  ngTableParams,
			  TGJobSvc,
			  LicenseOptionsSvc,
			  $cookies,
			  $localStorage) {

		var defaultTableParams = function () {
			return {
				page: 1, // show first page
				count: $scope.config.table.params.count, // count per page
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					search: '',
					converted: true,
					status: ['active'],
					licences: null,
					// onlyFutureJobs: true,
					// visitDateInFuture: true,
					// active: [1]
				},
				page_name: 'index'
			};
		};

		var initialParams = function () {
			if (angular.isDefined($localStorage.tgJobIndexParams)) {
				self.searchText = $localStorage.tgJobIndexParams.filter.search;
				return angular.extend({}, defaultTableParams(), $localStorage.tgJobIndexParams);
			}
			else {
				return angular.extend({}, defaultTableParams());
			}
		};

		function init() {

			self.statusOptions = [
				{
					value: 'active',
					label: 'Active'
				},
				{
					value: 'cancelled',
					label: 'Cancelled'
				}
			];


			LicenseOptionsSvc.license().then(function (response) {
				$scope.licenseOptions = response.data.options;
			});

			var params = initialParams();
			self.jobFilters = angular.copy(params.filter);
			self.tableParams = new ngTableParams(params, {
				total: 0, // length of data
				counts: $scope.config.table.settings.counts, // available page counts
				getData: function ($defer, params) {
					$localStorage.tgJobIndexParams = params.$params;
					TGJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.tg_job_filtered_count);
							$defer.resolve(response.data.tg_job_collection);
							$scope.$emit('jobIndexUpdated', {
								job_collection: response.data.tg_job_collection,
								job_filtered_count: response.data.tg_job_filtered_count,
								job_total_count: response.data.tg_job_total_count,
								job_total_value: response.data.total_quote_value
							});
							// Check if we've exceeded our page size, if we have, go back
							if (response.data.tg_job_filtered_count > 0 && !response.data.tg_job_collection.length) {
								let newParams = angular.copy(self.tableParams.$params);
								newParams.page--;
								angular.extend(self.tableParams.$params, newParams);
							}
							self.loading = false;
						});
				}
			});
		}

		// text search
		function filterChanged() {
			self.tableParams.$params.filter.search = self.searchText;
		}

		// Store the table params whenever anything changes
		$scope.$watch('tableParams.$params', function (value) {
			if (angular.isObject(value)) {
				$cookies.tgJobIndexParams = JSON.stringify(value);
			}
		}, true);

		// other filters
		function filterApply() {
			angular.extend(self.tableParams.$params.filter, angular.copy(self.jobFilters));
		}

		function filterReset() {
			angular.extend(self.tableParams.$params, defaultTableParams());
			angular.extend(self.jobFilters, defaultTableParams().filter);
		}

		function rowClicked (quote) {
			$state.go('main.trugreen.job.index.view', {
				jobId: quote.id
			});
		}

		$scope.$on('tgJobIndexExport', function () {
			var params = angular.copy(self.tableParams.$params);
			TGJobSvc.export(params);
		});

		var self = $scope.TGJobIndexCtrl = {
			loading: true,
			searchText: '',
			tableParams: null,
			licenses: null,
			jobFilters: null,
			statusOptions: null,
			methods: {
				init: init,
				filterChanged: filterChanged,
				filterApply: filterApply,
				filterReset: filterReset,
				rowClicked: rowClicked
			}
		}


	});
